import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-info-attachments',
  templateUrl: 'info-attachments.component.html',
  styleUrls: ['../common.scss']
})
export class InfoAttachmentsComponent {

  @Input() total: number = 0;

  @Input() clickable: boolean = false;

  @Input() showZero: boolean = true;

  @Output() click: EventEmitter<void> = new EventEmitter();
  
  onClick() {

    this.click.emit();

  }

}
